/** Public product name shown in UI */
export const APP_BRAND = "VIVO Exchange";
export const APP_BRAND_MARK = "VIVO";
export const APP_BRAND_TAIL = "Exchange";
